module.exports = __webpack_public_path__ + "static/media/PREdu.12348d6d.png";